import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'initialsImage',
  standalone: true,
})
export class InitialsImagePipe implements PipeTransform {
  public transform(
    name: string,
    size = 24,
    background = '#d97706',
    color = '#ffffff',
  ): string {
    if (!name) return '';

    const initials = name
      .split(' ')
      .map(part => part[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);

    const svg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
        <rect width="${size}" height="${size}" fill="${background}" rx="${size / 2}" shape-rendering="geometricPrecision"/>
        <text x="50%" y="50%" fill="${color}" font-family="Arial, Helvetica, sans-serif" font-size="${size / 2.5}" text-anchor="middle" dy=".3em">
          ${initials}
        </text>
      </svg>
    `;

    return `data:image/svg+xml;base64,${btoa(svg)}`;
  }
}
